<template>
  <div class="home">
    <Header
      class="header"
      :dark="pageActiveIndex !== 0"
    />
    <swiper ref="pageSwiper" :options="pageSwiperOptions" class="page-swiper">
      <swiper-slide class="swiper-slide">
        <section class="page-section swiper-top-container">
          <swiper ref="mainSwiper" :options="swiperOptions">
            <swiper-slide
              class="swiper-slide-row"
              v-for="(swiper, index) in swiperList"
              :key="index"
            >
              <div
                class="swiper-item"
                :style="{ backgroundImage: `url(${swiper})` }"
              >
                <div class="item-container" v-slide-in>
                  <p class="sub-title">专业不止于前</p>
                  <p class="title">曼世智造 推开饰界之门</p>
                  <a href="https://mp.weixin.qq.com/s/FXoIiYNIAqSvJboUg5qdVg" target="_blank">
                    <div class="more-btn">了解更多</div>
                  </a>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </section>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <section class="benz-series page-section">
          <swiper ref="mainSwiper" :options="swiperOptionsBenz">
            <swiper-slide
              class="swiper-slide-row"
              v-for="(swiper, index) in benzSeries"
              :key="index"
            >
              <div
                class="swiper-item"
                style="background-color: #F5F5F5;"
              >
                <div class="item-container" v-if="isMobile">
                  <div class="block">
                    <p class="title">{{ swiper.title }}</p>
                    <p class="sub-title">{{ swiper.subTitle }}</p>
                  </div>
                  <div class="block">
                    <p class="info">{{ swiper.info }}</p>
                    <p class="date">{{ swiper.date }}</p>
                    <p class="date" v-if="swiper.size">{{ swiper.size }}</p>
                  </div>
                  <div class="block">
                    <img :src="swiper.img" alt="">
                  </div>
                  <div class="block">
                    <img :src="swiper.img2" alt="">
                  </div>
                </div>
                <img v-else class="benz-image" :src="swiper.img3" alt="">
                <div class="more-btn" @click="$router.push({path: '/detail/' + (index + 1)})">了解更多</div>
              </div>
            </swiper-slide>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </section>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <section class="consultation-center page-section">
          <p class="title">资讯中心</p>
          <div class="tabs">
            <div
              @click="$router.push('/information?type=video')"
              class="tab active"
            >
              视频库
            </div>
            <!-- <div @click="$router.push('/information?type=picture')" class="tab">
              用户实拍
            </div> -->
            <div @click="$router.push('/information?type=news')" class="tab">
              曼世资讯
            </div>
          </div>
          <div class="video-container">
            <!-- <div class="aside-left">
              <img src="../assets/images/aside-left.png" width="100%" height="100%" alt="">
            </div> -->
            <swiper
              ref="centerSwiper"
              :options="isMobile ? swiperOption3 : swiperOption2"
              class="center-swiper"
            >
              <swiper-slide
                class="banner-item"
                v-for="(item, index) in bannerList"
                :key="index"
              >
                <video
                  v-if="item.type === 'video'"
                  :ref="'videoSlide'"
                  muted
                  controls
                  :autoplay="index === 1 && !isMobile"
                >
                  <source :src="item.url" type="video/mp4" />
                </video>
                <img
                  v-if="item.type === 'img'"
                  style="height: 100%; width: 100%;"
                  :src="item.url"
                />
              </swiper-slide>
            </swiper>

            <!-- <div class="aside-right">
              <img src="../assets/images/aside-right.png" width="100%" height="100%" alt="">
            </div> -->
          </div>
        </section>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <section class="brand-info-container page-section">
          <div class="brand-info">
            <p class="sub-title">品牌信息</p>
            <p class="title">专业不止于前</p>
            <p class="desc">
              曼世品牌自2009年成立以来，专注于汽车内外饰件的研发、生产和销售，致力于为客户提供全方位的汽车配件服务。品牌核心产品为德系中高端车型，并且开拓了如保时捷、特斯拉等多种新车型的配套产品。曼世始终将产品质量视为基石，以创新设计为驱动力，以卓越服务为后盾，不断为消费者带来卓越的产品和极致的用户体验。
            </p>
            <a href="https://mp.weixin.qq.com/s/FXoIiYNIAqSvJboUg5qdVg" target="_blank">
              <div class="more-btn">了解更多</div>
            </a>
            <div class="tel-container">
              <img src="../assets/images/tel.png" alt="" />
              <div class="tel">
                <p class="tel-number">400 008 1075</p>
                <p class="tel-desc">立刻联系我们，我们将为您提供专属服务</p>
              </div>
            </div>
          </div>
          <div class="brand-info-img">
            <img src="../assets/images/brandInfo.png" alt="" />
          </div>
        </section>
      </swiper-slide>
      <swiper-slide class="swiper-slide footer-container">
        <section class="home-footer-container page-section">
          <div class="footer-img">
            <div class="desc-list" v-for="(item, index) in footerDesc" :key="index">
              <p class="title">{{ item.title }}</p>
              <p class="sub-title">{{ item.subTitle }}</p>
            </div>
          </div>
          <Footer />
        </section>
      </swiper-slide>
      <div class="page-pagination-vertical" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import swiper1 from "@/assets/images/swiper1.png";
import swiper2 from "@/assets/images/swiper2.png";
import swiper3 from "@/assets/images/swiper3.png";
import benzSeries1 from "@/assets/images/benzSeries1.png";
import benzSeries2 from "@/assets/images/benzSeries2.png";
import benzSeries3 from "@/assets/images/benzSeries3.png";
import benzSeries4 from "@/assets/images/benzSeries4.png";
import benzSeries5 from "@/assets/images/benzSeries5.png";
import benz11 from '@/assets/images/benz/benz11.png';
import benz12 from '@/assets/images/benz/benz12.png';
import benz21 from '@/assets/images/benz/benz21.png';
import benz22 from '@/assets/images/benz/benz22.png';
import benz31 from '@/assets/images/benz/benz31.png';
import benz32 from '@/assets/images/benz/benz32.png';
import benz41 from '@/assets/images/benz/benz41.png';
import benz42 from '@/assets/images/benz/benz42.png';
import benz51 from '@/assets/images/benz/benz51.png';
import benz52 from '@/assets/images/benz/benz52.png';
import video1 from "@/assets/video/video1.mp4";
import asideLeft from "@/assets/images/aside-left.png"
import asideRight from "@/assets/images/aside-right.png"
export default {
  name: "Home",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      pageActiveIndex: 0,
      pageSwiperOptions: {
        direction: "vertical",
        mousewheel: true,
        slidesPerView: "auto",
        speed: 1000,
        on: {
          slideChangeTransitionEnd: () => {
            this.pageActiveIndex = this.$refs.pageSwiper.$swiper.activeIndex;
          },
        },
        
      },
      swiperList: [swiper1, swiper2, swiper3],
      activeIndex: 1,
      swiperOptions: {
        // effect: 'coverflow',
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 1000,
        grabCursor: true,
        watchSlidesProgress: true,
        loop: true,
        on: {
          slideChangeTransitionEnd: () => {
            if (this.$refs.mainSwiper && this.$refs.mainSwiper.$swiper) {
              const activeIndex = this.$refs.mainSwiper.$swiper.activeIndex;
              if (activeIndex === 4) {
                this.activeIndex = 1;
              } else {
                this.activeIndex = activeIndex;
              }
            }
          },
        },
      },
      swiperOptionsBenz: {
        speed: 500,
        loop: true,
        effect: 'fade',
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      },
      bannerList: [
        {
          url: asideLeft,
          type: 'img',
        },
        {
          url: video1,
          type: 'video',
        },
        {
          url: asideRight,
          type: 'img',
        },
      ],
      swiperOption2: {
        //设置平滑
        slidesPerView: 2.2,
        spaceBetween: 14,
        centeredSlides: true,
        // 默认第二个
        initialSlide: 1,
        on: {
          slideChangeTransitionEnd: () => {
            if(this.isMobile) return
            if (this.$refs.centerSwiper && this.$refs.centerSwiper.$swiper) {
              const activeIndex = this.$refs.centerSwiper.$swiper.activeIndex;
              const videoList = this.$refs["videoSlide"] || [];
              videoList.forEach((item, index) => {
                if (index === activeIndex) {
                  item.play && item.play();
                } else {
                  item.pause && item.pause();
                }
              });
            }
          },
        },
      },
      swiperOption3: {
        //设置平滑
        slidesPerView: 1.5,
        spaceBetween: 14,
        centeredSlides: true,
        // 默认第二个
        initialSlide: 1,
        on: {
          slideChangeTransitionEnd: () => {
            if(this.isMobile) return
            if (this.$refs.centerSwiper && this.$refs.centerSwiper.$swiper) {
              const activeIndex = this.$refs.centerSwiper.$swiper.activeIndex;
              const videoList = this.$refs["videoSlide"] || [];
              videoList.forEach((item, index) => {
                if (index === activeIndex) {
                  item.play && item.play();
                } else {
                  item.pause && item.pause();
                }
              });
            }
          },
        },
      },
      benzSeries: [
        {
          title: 'For Mercedes Benz',
          subTitle: 'Series',
          info: 'Grille',
          date: 'for E Class 2014-2015',
          img: benz11,
          img2: benz12,
          img3: benzSeries1
        },
        {
          title: 'For Tesla',
          subTitle: 'Series',
          info: 'Trunk table',
          date: 'for Model3 / ModelY 2019-2024',
          size: 'three size choose',
          img: benz21,
          img2: benz22,
          img3: benzSeries2
        },
        {
          title: 'For Mercedes Benz',
          subTitle: 'Series',
          info: 'Front bumper grille kit',
          date: 'for Maybach S480 Upgrades to S680 2021-2024',
          img: benz31,
          img2: benz32,
          img3: benzSeries3
        },
        {
          title: 'For Mercedes Benz',
          subTitle: 'Series',
          info: 'Front bumper guard',
          date: 'for GLE Class 2020-2023',
          img: benz41,
          img2: benz42,
          img3: benzSeries4
        },
        {
          title: 'For Mercedes Benz',
          subTitle: 'Series',
          info: 'Front bumper grille kit',
          date: 'for S Class Upgraded to Maybach S 2018-2020',
          img: benz51,
          img2: benz52,
          img3: benzSeries5
        },
      ],
      footerDesc: [
        {
          title: '质量第一',
          subTitle: 'Quality'
        },
        {
          title: '创新驱动',
          subTitle: 'Innovation'
        },
        {
          title: '诚信经营',
          subTitle: 'Integrity'
        },
        {
          title: '客户至上',
          subTitle: 'Service'
        },
      ],
      isMobile: false,
    };
  },
  created() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    checkDevice() {
      const mql = window.matchMedia('(max-width: 768px)');
      this.isMobile = mql.matches;
    },
    goToSlide(index) {
      this.$refs.pageSwiper.$swiper.slideTo(index);
    },
  }
};
</script>
<style lang="scss">
.swiper-pagination {
  .swiper-pagination-bullet {
    width: 0.6771vw;
    height: 0.6771vw;
    background-color: #fff;
    &.swiper-pagination-bullet-active {
      background-color: #1c2b74;
    }
  }
}
.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 0.9vw;
}
@media screen and (max-width: 768px ) {
  .home {
    .swiper-top-container {
      .sub-title {
        font-size: 1.38rem !important;
      }
      .title {
        margin-top: 1rem !important;
        font-size: 2rem !important;
      }
      .more-btn {
        margin-top: 1rem !important;
        width: 7rem !important;
        height: 2rem !important;
        font-size: .8rem !important;
      }
    }
    .benz-series {
      .swiper-item {
        // .item-container {
        //   flex-direction: column;
        //   height: 100%;
        //   padding-top: 20%;
        //   padding-left: 0;
        //   .block {
        //     height: 20% !important;
        //     width: 100% !important;
        //     text-align: center !important;
        //     padding: 0 !important;
        //     display: flex !important;
        //     justify-content: center !important;
        //     align-items: center !important;
        //     &:nth-child(1) {
        //       height: 12% !important;
        //       font-size: 1.5rem !important;
        //     }
        //     &:nth-child(2) {
        //       height: 12% !important;
        //       font-size: 1rem !important;
        //     }
        //   }
        // }
        .more-btn {
          width: 55% !important;
        }
      }
      .more-btn {
        bottom: 5rem !important;
        width: 7rem !important;
        height: 2rem !important;
        font-size: .7rem !important;
      }
    }
    .consultation-center {
      margin-top: 5rem !important;
      .title {
        font-size: 1.2rem !important;
      }
      .tabs {
        margin-top: 2rem !important;
        .tab {
          font-size: .8rem !important;
        }
      }
      .video-container {
        height: 50vh;
        margin-top: 3rem !important;
        // padding-left: 20vw;
        .center-swiper {
          height: 100% !important;
          margin: 0;
          overflow: hidden;
          
        // margin: 0 1.0417vw !important;
          .banner-item {
            height: 100% !important;
            overflow: hidden;
            video, img{
              max-width: 70vw !important;
            }
          }
        }
      }
      // .center-swiper {
      //   height: 100%;
      // }
    }
    .brand-info-container {
      margin-top: 4.1875rem !important;
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      .brand-info {
        width: 100%;
        text-align: center;
        padding: 0 !important;
        .sub-title {
          font-size: .8rem !important;
        }
        .title {
          margin-top: 1rem !important;
          font-size: 1.5rem !important;
        }
        .desc {
          margin-top: 1rem !important;
          width: auto !important;
          font-size: .73rem !important;
          line-height: 1rem !important;
          box-sizing: border-box !important;
          padding: 0 1.25rem !important;
        }
        .more-btn {
          margin-top: 2rem !important;
          margin: 0 auto;
          width: 7rem !important;
          height: 2rem !important;
          font-size: .7rem !important;
        }
        .tel-container {
          margin-top: 1.5rem !important;
          justify-content: center;
          img {
            width: 2rem !important;
            height: 2rem !important;
          }
          .tel {
            margin-left: 1rem !important;
            .tel-number {
              font-size: 1.5rem !important;
            }
            .tel-desc {
              font-size: .5rem !important;
              line-height: 1rem !important;
            }
          }
        }
      }
      
      .brand-info-img {
        margin-top: 2rem;
        width: 100% !important;
        height: auto !important;
      }
    }
    .home-footer-container {
      .footer-img {
        flex-direction: column;
        padding:35% 0 15% !important;
        // justify-content: center;
        .title {
          font-size: 1.5rem !important;
        }
        
        .sub-title {
          font-size: 1rem !important;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
// @media screen and (max-width: 768px ) {
//   .home {
//     .swiper-top-container {
//       .sub-title {
//         font-size: 1.38rem !important;
//       }
//       .title {
//         margin-top: 1rem !important;
//         font-size: 2rem !important;
//       }
//       .more-btn {
//         margin-top: 1rem !important;
//         width: 9rem !important;
//         height: 2rem !important;
//         font-size: .8rem !important;
//       }
//     }
//     .benz-series {
//       .swiper-item {}
//     }
//   }
// }
.home {
  height: 100vh;
  .page-swiper {
    width: 100%;
    height: 100%;
    .swiper-slide {
      height: 100vh;
      box-sizing: border-box;
    }
  }

  .page-section {
    width: 100%;
    box-sizing: border-box;
    &.swiper-top-container {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      .swiper-slide-row {
        // width: 100%;
        .swiper-item {
          height: 100vh;
          background-size: cover;
          // background: no-repeat center;
          .item-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 30vh;
            .sub-title {
              font-size: 2.3792vw;
              line-height: 1em;
              font-weight: 400;
              color: #fff;
            }
            .title {
              font-size: 4.4271vw;
              line-height: 1em;
              font-weight: 500;
              color: #fff;
              margin-top: 2.0833vw;
            }
            .more-btn {
              margin-top: 3.125vw;
              width: 11.4583vw;
              height: 3.9063vw;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
              font-size: 1.0417vw;
              background-color: #1c2b74;
              box-sizing: border-box;
              &:hover {
                color: #1c2b74;
                font-weight: 500;
                background-color: #fff;
                border: 0.1563vw solid #1c2b74;
              }
            }
          }
        }
      }
    }
    &.benz-series {
      width: 100%;
      background-color: #f5f5f5;
      position: relative;
      
      // padding-top: 8.5vw;
      box-sizing: border-box;
      .swiper-slide-row {
        height: 100vh;
      }
      .swiper-item {
        height: 100vh;
        width: 100%;
        .benz-image {
          margin-top: 5vw;
          width: 100%;
          // height: 100%;
          // object-fit: cover;
        }
        .item-container {
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          height: 100%;
          padding-left: 5%;
          // &:nth-child(1) {
          //   .block:nth-child(4) {
          //     img {
          //       width: 70% !important;
          //     }
          //   }
          // }
          // &:nth-child(2) {
          //   .block:nth-child(4) {
          //     position: relative !important;
          //     img {
          //       width: 200% !important;
          //       transform: translateY(-10vw) scale(1.5) !important;
          //     }
          //   }
          // }
          .block {
            width: 100%;
            height: 20%;
            padding-top: 30%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
            &:nth-child(1) {
              height: 13%;
            }
            &:nth-child(2) {
              height: 13%;
            }
            img {
              width: 80%;
              // height: 100%;
            }
            .title {
              font-size: 1.5rem;
            }
            .sub-title {
              font-size: 1.5rem;
            }
            .info {
              font-size: 1.5rem;
              font-weight: bold;
              position: relative;
              &::before {
                content: '◎';
                font-size: .8em;
                position: absolute;
                top: 0em;
                left: -1.2em;
              }
            }
            .date {
              font-size: 1rem;
            }
          }
        }
      }
      .more-btn {
        position: absolute;
        bottom: 7vw;
        right: 20.8333vw;
        margin: 0 auto;
        width: 12.5vw;
        height: 4.2708vw;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 1.0417vw;
        background-color: #1c2b74;
        box-sizing: border-box;
        transition: all 0.3s;
        &:hover {
          color: #1c2b74;
          font-weight: 500;
          background-color: #fff;
          border: 0.1563vw solid #1c2b74;
        }
      }
    }
    &.consultation-center {
      font-family: Source Han Sans CN;
      text-align: center;
      margin-top: 8vw;
      .title {
        font-weight: bold;
        font-size: 1.875vw;
      }
      .tabs {
        display: flex;
        justify-content: center;
        margin-top: 1.8vw;
        .tab {
          padding: 0 2.6042vw;
          text-align: center;
          font-size: 1.0938vw;
          color: #000000;
          cursor: pointer;
          &.active {
            font-weight: bold;
          }
        }
      }
      .video-container {
        margin-top: 3vw;
        width: 100%;
        height: 50vh;
        .aside-left {
          flex: 1;
          height: 100%;
        }
        .aside-right {
          flex: 1;
          height: 100%;
        }
      }
      .center-swiper {
        height: 100%;
        width: 100%;
        // margin: 0 1.0417vw;
        box-sizing: border-box;
        .banner-item {
          height: 100%;
          width: 100%;
          box-sizing: border-box;
          // &.swiper-slide-active {
          //   width: auto !important;
          // }
          video, img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
    &.brand-info-container {
      margin-top: 11vw;
      background-color: #fff;
      // padding-bottom: 5.2083vw;
      display: flex;
      padding-top: 0.5208vw;
      .brand-info {
        flex: 1;
        box-sizing: border-box;
        padding-left: 9.375vw;
        font-family: Source Han Sans CN;
        position: relative;
        .sub-title {
          font-weight: bold;
          font-size: 1.4583vw;
          line-height: 2.2em;
          font-weight: 500;
          font-family: Source Han Sans CN;
          color: #000000;
        }
        .title {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 2.3792vw;
          color: #000000;
        }
        .desc {
          font-family: Source Han Sans CN;
          width: 32.3vw;
          margin-top: 2vw;
          font-weight: 500;
          font-size: .9375vw;
          color: #000000;
          line-height: 1.3021vw;
          text-align: justify;
        }
        .more-btn {
          margin-top: 3.1771vw;
          width: 12.5vw;
          height: 4.2708vw;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 1.0417vw;
          background-color: #1c2b74;
          box-sizing: border-box;
          transition: all 0.3s;
          &:hover {
            color: #1c2b74;
            font-weight: 500;
            background-color: #fff;
            border: 0.1563vw solid #1c2b74;
          }
        }
        .tel-container {
          margin-top: 3vw;
          display: flex;
          img {
            width: 2.6042vw;
            height: 2.6042vw;
            margin-top: .3vw;
          }
          .tel {
            font-family: Source Han Sans CN;
            color: #000000;
            margin-left: 0.6771vw;
            .tel-number {
              font-family: Source Han Sans CN;
              font-weight: bold;
              font-size: 2.3792vw;
            }
            .tel-desc {
              font-family: Source Han Sans CN;
              font-weight: 500;
              font-size: 0.7813vw;
              line-height: 1.3021vw;
            }
          }
        }
      }
      .brand-info-img {
        width: 53vw;
        height: 29.8438vw;
        overflow: hidden;
        &:hover img {
          transform: scale(1.05);
        }
        img {
          transition: all 0.3s;
          width: 100%;
          height: 100%;
        }
      }
    }
    &.home-footer-container {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding-top: 8vw;
      .footer-img {
        flex: 1;
        width: 100%;
        background-image: url('../assets/images/footer.png');
        background-size: cover;
        background-position: center center;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        padding: 0 20vw;
        box-sizing: border-box;
        .desc-list {
          flex: 1;
          color: #fff;
          text-align: center;
          .title {
            font-family: Source Han Sans CN;
            font-size: 2vw;
            line-height: 2em;
            letter-spacing: .2em;
          }
          .sub-title {
            font-family: Source Han Sans CN;
            font-size: 1.3vw;
            line-height: 2em;
          }
        }
      }
    }
  }
}

</style>
